// Access token storage. Kept in memory only: persisting bearer tokens in
// localStorage/sessionStorage lets any XSS payload exfiltrate them.
let accessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function clearAccessToken(): void {
  accessToken = null;
}

// Remove tokens persisted by older versions of the app.
export function clearLegacyTokenStorage(): void {
  try {
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refresh_token');
  } catch {
    // Storage may be unavailable (private mode); nothing to clean up.
  }
}
